module.exports = __webpack_public_path__ + "img/icons_date.efb8301b.svg";